import { render, staticRenderFns } from "./ThreadTimeline.vue?vue&type=template&id=1812ee15&scoped=true&"
import script from "./ThreadTimeline.vue?vue&type=script&lang=js&"
export * from "./ThreadTimeline.vue?vue&type=script&lang=js&"
import style0 from "./ThreadTimeline.vue?vue&type=style&index=0&id=1812ee15&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1812ee15",
  null
  
)

export default component.exports